import Storage from "@/utils/storage";

const INTERVAL_MS = 12 * 60 * 60 * 1000;

export function shouldShowAicopyHomePromo() {
  if (typeof window === "undefined") return false;
  const lastShownAt = Number(Storage.get("aicopyHomePromo"));
  if (!Number.isFinite(lastShownAt) || lastShownAt <= 0) return true;
  return Date.now() - lastShownAt >= INTERVAL_MS;
}

export function markAicopyHomePromoShown() {
  Storage.set("aicopyHomePromo", Date.now());
}
